export const GET_PROFILE_REQUEST = '@OXD/GET_PROFILE_REQUEST'
export const GET_PROFILE_SUCCESS = '@OXD/GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAILURE = '@OXD/GET_PROFILE_FAILURE'

export const UPDATE_USER_PROFILE = '@OXD/UPDATE_USER_PROFILE'
export const UPDATE_ANON_USER_PROFILE = '@OXD/UPDATE_ANON_USER_PROFILE'

export const UPDATE_PROFILE_REQUEST = '@OXD/UPDATE_PROFILE_REQUEST'
export const UPDATE_PROFILE_SUCCESS = '@OXD/UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAILURE = '@OXD/UPDATE_PROFILE_FAILURE'

export const CHANGE_PASSWORD_REMOVE_ERROR = '@OXD/CHANGE_PASSWORD_REMOVE_ERROR'
export const CHANGE_PASSWORD_REQUEST = '@OXD/CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = '@OXD/CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = '@OXD/CHANGE_PASSWORD_FAILURE'

export const SAVE_SEARCH = '@OXD/SAVE_SEARCH'
export const SAVE_SEARCH_REQUEST = '@OXD/SAVE_SEARCH_REQUEST'
export const SAVE_SEARCH_SUCCESS = '@OXD/SAVE_SEARCH_SUCCESS'
export const SAVE_SEARCH_FAILURE = '@OXD/SAVE_SEARCH_FAILURE'

export const GET_SAVED_SEARCHES_REQUEST = '@OXD/GET_SAVED_SEARCHES_REQUEST'
export const GET_SAVED_SEARCHES_SUCCESS = '@OXD/GET_SAVED_SEARCHES_SUCCESS'
export const GET_SAVED_SEARCHES_FAILURE = '@OXD/GET_SAVED_SEARCHES_FAILURE'

export const REMOVE_SAVED_SEARCH = '@OXD/REMOVE_SAVED_SEARCH'
export const REMOVE_SAVED_SEARCH_REQUEST = '@OXD/REMOVE_SAVED_SEARCH_REQUEST'
export const REMOVE_SAVED_SEARCH_SUCCESS = '@OXD/REMOVE_SAVED_SEARCH_SUCCESS'
export const REMOVE_SAVED_SEARCH_FAILURE = '@OXD/REMOVE_SAVED_SEARCH_FAILURE'

export const ADD_FAVOURITE = '@OXD/ADD_FAVOURITE'
export const ADD_FAVOURITE_REQUEST = '@OXD/ADD_FAVOURITE_REQUEST'
export const ADD_FAVOURITE_SUCCESS = '@OXD/ADD_FAVOURITE_SUCCESS'
export const ADD_FAVOURITE_FAILURE = '@OXD/ADD_FAVOURITE_FAILURE'

export const ADD_DIRECT_FAVOURITE = '@OXD/ADD_DIRECT_FAVOURITE'
export const ADD_DIRECT_FAVOURITE_REQUEST = '@OXD/ADD_DIRECT_FAVOURITE_REQUEST'
export const ADD_DIRECT_FAVOURITE_SUCCESS = '@OXD/ADD_DIRECT_FAVOURITE_SUCCESS'
export const ADD_DIRECT_FAVOURITE_FAILURE = '@OXD/ADD_DIRECT_FAVOURITE_FAILURE'

export const ADD_SIGNUP_FAVOURITE_VEHICLE = '@OXD/ADD_SIGNUP_FAVOURITE_VEHICLE'

export const ADD_SIGNUP_DIRECT_FAVOURITE_VEHICLE = '@OXD/ADD_SIGNUP_DIRECT_FAVOURITE_VEHICLE'

export const REMOVE_FAVOURITE = '@OXD/REMOVE_FAVOURITE'
export const REMOVE_FAVOURITE_REQUEST = '@OXD/REMOVE_FAVOURITE_REQUEST'
export const REMOVE_FAVOURITE_SUCCESS = '@OXD/REMOVE_FAVOURITE_SUCCESS'
export const REMOVE_FAVOURITE_FAILURE = '@OXD/REMOVE_FAVOURITE_FAILURE'

export const REMOVE_DIRECT_FAVOURITE = '@OXD/REMOVE_DIRECT_FAVOURITE'
export const REMOVE_DIRECT_FAVOURITE_REQUEST = '@OXD/REMOVE_DIRECT_FAVOURITE_REQUEST'
export const REMOVE_DIRECT_FAVOURITE_SUCCESS = '@OXD/REMOVE_DIRECT_FAVOURITE_SUCCESS'
export const REMOVE_DIRECT_FAVOURITE_FAILURE = '@OXD/REMOVE_DIRECT_FAVOURITE_FAILURE'

export const REMOVE_FAVOURITES_REQUEST = '@OXD/REMOVE_FAVOURITES_REQUEST'
export const REMOVE_FAVOURITES_SUCCESS = '@OXD/REMOVE_FAVOURITES_SUCCESS'
export const REMOVE_FAVOURITES_FAILURE = '@OXD/REMOVE_FAVOURITES_FAILURE'

export const REMOVE_DIRECT_FAVOURITES_REQUEST = '@OXD/REMOVE_DIRECT_FAVOURITES_REQUEST'
export const REMOVE_DIRECT_FAVOURITES_SUCCESS = '@OXD/REMOVE_DIRECT_FAVOURITES_SUCCESS'
export const REMOVE_DIRECT_FAVOURITES_FAILURE = '@OXD/REMOVE_DIRECT_FAVOURITES_FAILURE'

export const GET_FAVOURITES_REQUEST = '@OXD/GET_FAVOURITES_REQUEST'
export const GET_FAVOURITES_SUCCESS = '@OXD/GET_FAVOURITES_SUCCESS'
export const GET_FAVOURITES_FAILURE = '@OXD/GET_FAVOURITES_FAILURE'

export const GET_DIRECT_FAVOURITES_REQUEST = '@OXD/GET_DIRECT_FAVOURITES_REQUEST'
export const GET_DIRECT_FAVOURITES_SUCCESS = '@OXD/GET_DIRECT_FAVOURITES_SUCCESS'
export const GET_DIRECT_FAVOURITES_FAILURE = '@OXD/GET_DIRECT_FAVOURITES_FAILURE'

export const DELETE_ACCOUNT_REQUEST = '@OXD/DELETE_ACCOUNT_REQUEST'
export const DELETE_ACCOUNT_SUCCESS = '@OXD/DELETE_ACCOUNT_SUCCESS'
export const DELETE_ACCOUNT_FAILURE = '@OXD/DELETE_ACCOUNT_FAILURE'
export const DELETE_ACCOUNT_REMOVE_ERROR = '@OXD/DELETE_ACCOUNT_REMOVE_ERROR'

export const DOWNLOAD_ACCOUNT_DATA_REQUEST = '@OXD/DOWNLOAD_ACCOUNT_DATA_REQUEST'
export const DOWNLOAD_ACCOUNT_DATA_SUCCESS = '@OXD/DOWNLOAD_ACCOUNT_DATA_SUCCESS'
export const DOWNLOAD_ACCOUNT_DATA_FAILURE = '@OXD/DOWNLOAD_ACCOUNT_DATA_FAILURE'
export const DOWNLOAD_ACCOUNT_DATA_RESET = '@OXD/DOWNLOAD_ACCOUNT_DATA_RESET'
